import {IReduxLocaleState} from '../../@interfaces';

const state: IReduxLocaleState = {
	locale: 'en',
	fallbackLocale: 'en',
	messagesLoaded: false,
	updatedAt: 0,
};

export default state;
